import React from 'react'
import styled from 'styled-components'
import { darken, lighten } from 'polished'
import { createDynamicStyle, attachStyle } from 'cms/helpers/styledComponents'

const CmsButton2 = styled(
  ({
    as,
    content,
    children,
    className,
    style,
    onClick,
  }) => {
    const Elm = as || 'button'
    return (
      <Elm className={className} style={style} onClick={onClick}>
        {content || children}
      </Elm>
    )
  }
)`
  ${({ theme, theme: { cms: { button }, colors }, size, basic, secondary }) => ({
    cursor: 'pointer',
    display: 'inline-block',
    minHeight: '1em',
    outline: 'none',
    border: 'none',
    verticalAlign: 'baseline',
    fontStyle: 'normal',
    textAlign: 'center',
    textDecoration: 'none',
    padding: '0.75em 1.25em',
    ...createDynamicStyle(theme, 'cms', 'button', 'style')({
      fontSize: button.fontSize[size],
      ...attachStyle(secondary, {
        backgroundColor: colors.secondary,
        color: colors.invertedSecondary,
      }),
      ...attachStyle(basic, {
        border: `0.1em solid ${colors.primary}`,
        backgroundColor: colors.invertedPrimary,
        color: colors.primary,
      }),
      ...attachStyle(basic && secondary, {
        border: `0.1em solid ${colors.secondary}`,
        backgroundColor: colors.invertedSecondary,
        color: colors.secondary,
      }),
    }),
    ':hover': {
      backgroundColor: lighten(0.2, colors.primary),
      ...attachStyle(secondary, {
        backgroundColor: lighten(0.2, colors.secondary),
      }),
      ...attachStyle(basic, {
        backgroundColor: darken(0.08, colors.primary),
      }),
      ...attachStyle(basic && secondary, {
        backgroundColor: darken(0.08, colors.secondary),
      }),
    }
  })}
`

CmsButton2.propTypes = {}
CmsButton2.defaultProps = {}

export default CmsButton2



// WEBPACK FOOTER //
// ./src/cms/CmsButton.js